import {optionalText} from '../../core/resolutionUtils';

/**
 * Return an Access Point identifier from a Canvas row.
 * @param {object} item Canvas Access Point row
 * @return {*|null} identifier
 */
export function accessPointId(item) {
	return item?.serial_no ??
		item?.ap_serial_no ??
		item?.serial_number ??
		item?.serialNo ??
		item?.ap_id ??
		item?.id ??
		null;
}

/**
 * Normalize a Canvas Access Point row for agent resolution.
 * @param {object} item Canvas Access Point row
 * @return {object|null} normalized reference
 */
export function normalizeAccessPointReference(item) {
	const safeId = optionalText(accessPointId(item));
	if (!safeId) return null;
	const safeName = [item?.ap_name, item?.device_name, item?.name]
		.map(optionalText)
		.find(Boolean) || safeId;
	return {
		entity_type: 'ap',
		entity_id: safeId,
		name: safeName,
		mac_address: optionalText(
			item.mac_address ?? item.macAddress ?? item.mac,
		),
		ip_address: optionalText(
			item.ip_address ?? item.ipAddress ?? item.ipv4_address ??
			item.ipv4 ?? item.ip_address_v4,
		),
		ipv6_address: optionalText(
			item.ipv6_address ?? item.ipv6Address ?? item.ipv6 ??
			item.ip_address_v6,
		),
		site_id: optionalText(item.site_id),
		site_name: optionalText(
			item.site_name ?? item.siteName ?? item.groupName,
		),
		status: optionalText(item.status ?? item.is_connected),
		serial_no: safeId,
		is_tip_enabled: item.is_tip_enabled == null
			? null
			: Number(item.is_tip_enabled) === 1,
	};
}

/**
 * Build the minimum AP row accepted by the existing dashboard route.
 * @param {object} params semantic navigation parameters
 * @return {object|null} Canvas route row
 */
export function buildAccessPointRouteRow(params = {}) {
	const id = params.ap_id ?? params.entity_id;
	const name = params.ap_name ?? params.entity_name;
	if (id == null || !String(id).trim() || !name || !String(name).trim()) {
		return null;
	}
	return {
		serial_no: String(id).trim(),
		ap_name: String(name).trim(),
		site_id: params.site_id || null,
		siteName: params.site_name || null,
	};
}
